import router from './router'
import NProgress from 'nprogress' // progress bar
import {getToken, resetPwdNeeded} from '@/utils/auth'
import store from "./store";
import getters from "./store/getters";
import Cookies from "js-cookie"; // getToken from cookie




NProgress.configure({
  showSpinner: false
})


function hasPermission(menus, permissionMenus) {
  if (!permissionMenus) return true;
  return menus.some(menu => permissionMenus.indexOf(menu) >= 0)
}

const whiteList = ['/login','/loginFromP13','/course_list','/course_play','/select_role','/course_my','/course_calendar','/watch_history','/conversation'];

router.beforeEach((to, from, next) => {
  console.log(to.path, '导航守卫', whiteList.indexOf(to.path), getToken());
  NProgress.start()
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next()
      NProgress.done()
    }else     if (to.path === '/login0c7a4ac4') {
      next()
      NProgress.done()
    } else {

      if(!localStorage.getItem('routers')){
        //左侧导航
        const res = new Map();
        if(JSON.parse(localStorage.getItem('menu')) != null){
          let newRouters = JSON.parse(localStorage.getItem('menu')).filter((a) => !res.has(a.id) && res.set(a.id, 1))
          // var routers = JSON.parse(localStorage.getItem('menu'));
          // var newArr = sortArr( routers, 'parent')
          var parentMenu = {
            flow_config: {
              title:'讲师管理',
              icon: 'el-icon-s-promotion',
              children: []
            },
            roles:  {
              title:'培训班管理',
              icon:'el-icon-s-custom',
              children:[]
            },
            Reservation:{
              title:'制式课程&监测',
              icon:'el-icon-s-check',
              children:[]
            },
            dailyLog:{
              title: '日志',
              icon: 'el-icon-notebook-2',
              children:[]
            },
            question:{
              title: '考试管理',
              icon: 'el-icon-s-order',
              children:[]
            },
            classroom:{
              title: '虚拟主播',
              icon: 'el-icon-school',
              children:[]
            },
            hotel:{
              title: 'chatgpt',
              icon: 'el-icon-office-building',
              children:[]
            },
            caterings:{
              title: '餐饮管理',
              icon: 'el-icon-hot-water',
              children:[]
            },
            messages:{
              title: '消息中心',
              icon: 'el-icon-s-comment',
              children:[]
            },
            stock:{
              title: '视频管理',
              icon: 'el-icon-set-up',
              children:[]
            },
            statistics:{
              title: '数据统计',
              icon: 'el-icon-s-finance',
              children:[]
            },
            scan:{
              title: '扫码',
              icon: 'el-icon-full-screen',
              children:[]
            },
            basics:{
              title: '系统管理',
              icon: 'el-icon-setting',
              children:[]
            },
          }
          var level3Menu = [];  //三级菜单
          newRouters.forEach(function (item) {
            if(parentMenu[item.parent] !== undefined) {
              parentMenu[item.parent].children.push({title:item.name, pathName:item.path,id:item.orderid,children:[]})
            } else {
              level3Menu.push({title:item.name, pathName:item.path,id:item.orderid,parent:item.parent})
            }
          })
          for(var j in parentMenu) {
            if (parentMenu[j].children.length > 0) {
              parentMenu[j].children = sortByKey(parentMenu[j].children,'id')
            }
          }
          var menu = []
          for(var i in parentMenu) {
            if (parentMenu[i].children.length > 0) {
              menu.push(parentMenu[i]);
            }
          }

          let role_names = JSON.parse(localStorage.getItem('users')).role_names
          if (role_names.includes('教务人员')) {
            menu.forEach(item => {
              if(item.title === '教务管理'){
                item.children.unshift({title:'我的预约',pathName:'administration_mytrain',id:0})
              }
            })
          }
          //处理第三级菜单
          menu.forEach(item => {
            if (item.children.length > 0 && level3Menu.length > 0) {
              item.children.forEach(i => {
                level3Menu.forEach(j => {
                  if (i.pathName == j.parent) {
                    i.children.push({title:j.title,pathName:j.pathName,id:j.id})
                  }
                })
                if(i.children !==undefined && i.children.length > 0) {
                  i.children.splice(0,0,{title:i.title,pathName:i.pathName,id:0})
                  i.children = sortByKey(i.children,'id')
                }
              });
            }
          })
          localStorage.setItem('routers',JSON.stringify(menu))
          localStorage.removeItem('menu')
          //左侧导航
        }

      }
      next()

    }
  } else {
    console.log(to.path);
    console.log(whiteList.indexOf(to.path));
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    }else  if (to.path === '/loginFromP13' || to.path == "/largescreen" || to.path == "/regular" || to.path == "/no_login") {
      next();
      NProgress.done()
    } else {
      next('/login');
      NProgress.done();
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})


// 传入一个数组 格式化数组
function sortArr(arr, str) {
  var _arr = [],
    _t = [],
    // 临时的变量
    _tmp;

  // 按照特定的参数将数组排序将具有相同值得排在一起
  arr = arr.sort(function(a, b) {
    var s = a[str],
      t = b[str];

    return s < t ? -1 : 1;
  });

  if ( arr.length ){
    _tmp = arr[0][str];
  }
  // console.log( arr );
  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    if ( arr[i][str] === _tmp ){
      _t.push( arr[i] );
    } else {
      _tmp = arr[i][str];
      _arr.push( _t );
      _t = [arr[i]];
    }
  }
  // 将最后的内容推出新数组
  _arr.push( _t );
  return _arr;
}


function sortByKey(array,key){
  return array.sort(function(a,b){
    var x = a[key];
    var y = b[key];
    return((x<y)?-1:((x>y)?1:0));
  })
}



// WEBPACK FOOTER //
// ./src/permission.js